// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52bca406","667":"97326cf5"}[chunkId] + ".chunk.js";
};